"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var constants_1 = require("../../../constants");
var VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
var commonweb_utils_1 = require("commonweb-utils");
var phones_1 = require("../../../actions/phones");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var manage_generic_component_1 = require("../../../components/manage-generic.component");
var utils_1 = require("../../../common/utils/phones/utils");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var page = require("page");
var ManagePhones = /** @class */ (function (_super) {
    tslib_1.__extends(ManagePhones, _super);
    function ManagePhones(props) {
        var _this = _super.call(this, props) || this;
        _this.setSpinner = function (status) {
            _this.setState({ showSpinner: status });
        };
        _this.props.changePrimaryType("");
        _this.state = {
            showSpinner: false,
            errorMessage: "",
        };
        return _this;
    }
    ManagePhones.prototype.handleToastClose = function (obj) {
        if (this.props.typeOfAction) {
            if (this.props.typeOfAction !== "remove") {
                commonUtils_1.modifyObjectWithFactor(obj, this.props.typeOfAction, true, false);
            }
            this.props.performedAction(null);
        }
    };
    ManagePhones.prototype.createToast = function (id, message, action, obj) {
        var _this = this;
        triggerOperationResult_1.triggerOperationResult(action, FPTI.SUCCESS, null);
        return (React.createElement(pp_react_1.Toast, { id: id, message: message, isSuccess: true, onClose: function (e) { return _this.handleToastClose(obj); }, duration: 6000 }));
    };
    ManagePhones.prototype.render = function () {
        var phoneContent = this.props.content.phones, commonContent = this.props.content.common, phoneAll = this.props.phones, phoneObj = [], phoneFpti = this.props.phoneFpti, form;
        for (var phone in phoneAll) {
            if (!(phone === "sys") && !(phone === "typeOfAction")) {
                if (phoneAll.hasOwnProperty(phone)) {
                    phoneObj.push(phoneAll[phone]);
                }
            }
        }
        form = (React.createElement("form", null,
            this.props.typeOfAction ===
                VIEWS.PHONES.TOAST_INTENTS.SET_PRIMARY &&
                this.createToast("set_primary", phoneContent.updatePrimary.toast, phoneFpti.setAsPrimary, phoneObj),
            this.props.typeOfAction ===
                VIEWS.PHONES.TOAST_INTENTS.REMOVE &&
                this.createToast("remove_phone", phoneContent.remove.toast, phoneFpti.remove, phoneObj),
            this.props.typeOfAction === VIEWS.PHONES.TOAST_INTENTS.ADD &&
                this.createToast("add_phone", phoneContent.add.toast, phoneFpti.add, phoneObj),
            this.props.typeOfAction === VIEWS.PHONES.TOAST_INTENTS.EDIT &&
                this.createToast("add_phone", phoneContent.update.toast, phoneFpti.edit, phoneObj),
            this.props.typeOfAction ===
                VIEWS.PHONES.TOAST_INTENTS.CONFIRM &&
                this.createToast("confirm_phone", phoneContent.confirm.toast, phoneFpti.edit, phoneObj),
            this.props.typeOfAction ===
                VIEWS.PHONES.TOAST_INTENTS.UPDATE_PRIMARY &&
                this.createToast("confirm_phone", phoneContent.updatePrimary.toast, phoneFpti.edit, phoneObj),
            phoneObj && phoneObj.length > 0 && (React.createElement(manage_generic_component_1.ManageBodyComponent, { ref: this, objTobeRendered: phoneObj, type: "PHONES", content: phoneContent, commonContent: commonContent, fpti: phoneFpti, props: this.props, setSpinner: this.setSpinner }))));
        return (React.createElement("div", { className: "generic-container" }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "panelSpinnerNew", size: "lg" })) : (form)));
    };
    return ManagePhones;
}(React.Component));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, features = _a.features, fpti = _a.fpti;
    var phones = commonweb_utils_1.objectUtils.safeGet(account, "phones.phones") || {}, typeOfAction = commonweb_utils_1.objectUtils.safeGet(account, "phones.typeOfAction") || {}, phoneFpti = fpti.phones;
    phones = utils_1.changeNumberFormatForNonSCARegions(phones, utils_1.isSCAEnabled(features));
    return {
        _csrf: _csrf,
        ui: ui,
        route: route,
        content: content,
        phones: phones,
        features: features,
        phoneFpti: phoneFpti,
        typeOfAction: typeOfAction,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        performedAction: function (typeOfAction) { return dispatch(phones_1.removeToast(typeOfAction)); },
        changePrimaryType: function (changePrimaryPhoneType) {
            return dispatch(phones_1.changePrimaryType(changePrimaryPhoneType));
        },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ManagePhones);
